import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { BASE_URL } from "./Url";
import axios from "axios";
const Checkbox = (props) => (
  <input style={{ transform: "scale(1.3)" }} type="checkbox" {...props} />
);

const SelectPagginationForInvoice = ({
  handleMultiInputChange,
  inputProduct,
  ProductsList,
  defaultValue,
  setProductsList,
  inputQuery,
  mobile,
}) => {
  const ref = useRef(null);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [next, setNext] = useState(null);
  const userProfile = JSON.parse(window.localStorage.getItem("userData"));
  const toggleMenuIsOpen = () => {
    setMenuIsOpen((value) => !value);
    const selectEl = ref.current;
    if (!selectEl) return;
    if (menuIsOpen) selectEl.blur();
    else selectEl.focus();
  };
  //   const getProductList = () => {
  //     if (inputQuery?.length > 1) {
  //       let url;
  //       if (!inputQuery || inputQuery === "" || inputQuery === undefined) {
  //         url = `${BASE_URL}api/v1/inventory/inventory/product_list_for_invoice_pagination/`;
  //       } else if (inputQuery) {
  //         url = `${BASE_URL}api/v1/inventory/inventory/product_list_for_invoice_pagination/?query=${inputQuery}`;
  //       }
  //       axios
  //         .get(url)
  //         .then((res) => {
  //           // console.log("productlistinvoice", res.data);
  //           const previous = res.data.data.previous
  //           const next = res.data.data.next
  //           const result = res.data.data.results;
  //           const options = result.map((curr) => ({
  //             label: curr.name + " " + "[[" + curr?.sku + "]]",
  //             value: curr.id,
  //             price: curr.price,
  //             discount: curr.discount,
  //             stock: curr.stock,
  //             variant: curr.variants,
  //             thumb: `${curr.thumb_url}`,
  //           }));

  //           setProductsList(options);
  //           // SetisLoading(false);
  //         })
  //         .catch((err) => {
  //           // const message = JSON.parse(err.request.response).message;
  //           // console.log(err.request.response);
  //         });
  //     }
  //   };
  const getProductList = (
    inputQuery,
    setProductsList,
    setLoading,
    next,
    setNext
  ) => {
    if (inputQuery?.length > 1) {
      // let url;
      // if (!inputQuery || inputQuery === "" || inputQuery === undefined) {
      //   url = `${BASE_URL}api/v1/inventory/inventory/product_list_for_invoice_pagination/${
      //     userProfile?.outlet
      //   }/outlet/${mobile && mobile !== undefined &&`?mobile=${mobile?.replace("+", "")}`}`;
      // } else if (inputQuery) {
      //   url = `${BASE_URL}api/v1/inventory/inventory/product_list_for_invoice_pagination/${
      //     userProfile?.outlet
      //   }/outlet/?query=${inputQuery}&limit=20${
      //     mobile && mobile !== undefined && `&mobile=${mobile?.replace("+", "")}`
      //   }`;
      // }
      // 29/7/24
      let url;

      if (!inputQuery || inputQuery === "" || inputQuery === undefined) {
        url = `${BASE_URL}api/v1/inventory/inventory/product_list_for_invoice_pagination/${
          userProfile?.outlet
        }/outlet/${
          mobile && mobile !== undefined
            ? `?mobile=${mobile.replace("+", "")}`
            : ""
        }`;
      } else if (inputQuery) {
        url = `${BASE_URL}api/v1/inventory/inventory/product_list_for_invoice_pagination/${
          userProfile?.outlet
        }/outlet/?query=${inputQuery}&limit=20${
          mobile && mobile !== undefined
            ? `&mobile=${mobile.replace("+", "")}`
            : ""
        }`;
      }
      console.log(mobile, "mm");

      setLoading(true); // Set loading state to true

      axios
        .get(url)
        .then((res) => {
          const { results } = res.data.data;
          console.log(results, "112");

          // Flatten variants - each variant becomes a separate option
          const options = [];
          results.forEach((product) => {
            if (product.variants && product.variants.length > 0) {
              product.variants.forEach((variant) => {
                // Format: "Product Name [CODE] - VariantName [[SKU]]"
                const variantLabel = `${product.name} [${product.sku}] - ${variant.name} [[SKU${variant.id}]]`;
                options.push({
                  label: variantLabel,
                  value: variant.id,
                  price:
                    variant.calculated_price !== undefined
                      ? variant.calculated_price
                      : 0,
                  product_main_price: 0,
                  discount: product.discount,
                  stock: variant.stock,
                  variant: [variant], // Single variant array
                  variantData: variant, // Store variant data
                  productData: product, // Store product data
                  thumb:
                    product.thumb_url ||
                    `${BASE_URL}media/default/lazy_placeholder.jpg`,
                  image: product?.thumb_resized_url
                    ? product.thumb_resized_url
                    : `${BASE_URL}media/default/lazy_placeholder.jpg`,
                  compared_offer_details: product.compared_offer_details,
                  productName: product.name,
                  productSku: product.sku,
                  variantName: variant.name,
                  variantSku: variant.id,
                });
              });
            } else {
              // If no variants, show product as is
              options.push({
                label: product.name + " " + "[[" + product?.sku + "]]",
                value: product.id,
                price: 0,
                product_main_price: 0,
                discount: product.discount,
                stock: product.stock,
                variant: [],
                thumb: `${product.thumb_url}`,
                image: `${
                  product?.thumb_resized_url
                    ? product.thumb_resized_url
                    : `${BASE_URL}media/default/lazy_placeholder.jpg`
                }`,
                compared_offer_details: product.compared_offer_details,
              });
            }
          });
          setProductsList(options); // Append new data to the existing list
          setNext(res.data.data.next); // Update next state

          setLoading(false); // Set loading state to false
        })
        .catch((err) => {
          console.error("Error fetching product list:", err);
          setLoading(false); // Set loading state to false even if there's an error
        });
    }
  };
  const getProductListNext = (
    inputQuery,
    setProductsList,
    setLoading,
    next,
    setNext
  ) => {
    setLoading(true); // Set loading state to true

    axios
      .get(next)
      .then((res) => {
        const { results } = res.data.data;

        // Flatten variants - each variant becomes a separate option
        const options = [];
        results.forEach((product) => {
          if (product.variants && product.variants.length > 0) {
            product.variants.forEach((variant) => {
              // Format: "Product Name [CODE] - VariantName [[SKU]]"
              const variantLabel = `${product.name} [${product.sku}] - ${variant.name} [[SKU${variant.id}]]`;
              options.push({
                label: variantLabel,
                value: variant.id,
                price:
                  variant.calculated_price !== undefined
                    ? variant.calculated_price
                    : 0,
                product_main_price: 0,
                discount: product.discount,
                stock: variant.stock,
                variant: [variant], // Single variant array
                variantData: variant, // Store variant data
                productData: product, // Store product data
                thumb:
                  product.thumb_url ||
                  `${BASE_URL}media/default/lazy_placeholder.jpg`,
                image: product?.thumb_resized_url
                  ? product.thumb_resized_url
                  : `${BASE_URL}media/default/lazy_placeholder.jpg`,
                compared_offer_details: product.compared_offer_details,
                productName: product.name,
                productSku: product.sku,
                variantName: variant.name,
                variantSku: variant.id,
              });
            });
          } else {
            // If no variants, show product as is
            options.push({
              label: product.name + " " + "[[" + product?.sku + "]]",
              value: product.id,
              price: 0,
              product_main_price: 0,
              discount: product.discount,
              stock: product.stock,
              variant: [],
              thumb: `${product.thumb_url}`,
              image: `${
                product?.thumb_resized_url
                  ? product.thumb_resized_url
                  : `${BASE_URL}media/default/lazy_placeholder.jpg`
              }`,
              compared_offer_details: product.compared_offer_details,
            });
          }
        });
        setProductsList((prevList) => [...prevList, ...options]); // Append new data to the existing list
        setNext(res.data.data.next); // Update next state

        setLoading(false); // Set loading state to false
      })
      .catch((err) => {
        console.error("Error fetching product list:", err);
        setLoading(false); // Set loading state to false even if there's an error
      });
  };

  useEffect(() => {
    let timeoutId;
    const delayedFetch = () => {
      timeoutId = setTimeout(() => {
        getProductList(inputQuery, setProductsList, setLoading, next, setNext);
      }, 1000); //
    };
    delayedFetch();
    return () => {
      clearTimeout(timeoutId);
    };
  }, [inputQuery]);
  useEffect(() => {
    if (ProductsList?.length > 0) {
      setMenuIsOpen(true);
    }
  }, [ProductsList]);
  const handleLoadMore = () => {
    getProductListNext(inputQuery, setProductsList, setLoading, next, setNext);
  };
  // useEffect(() => {
  //   if ( next !== null && !loading) {
  //     setTimeout(handleLoadMore, 2000);
  //   }

  // }, [next, loading]);

  const CustomOption = ({ innerRef, innerProps, data }) => {
    const imageUrl =
      data.image ||
      data.thumb ||
      `${BASE_URL}media/default/lazy_placeholder.jpg`;

    return (
      <div
        ref={innerRef}
        {...innerProps}
        className="custom-option"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "8px 10px",
          cursor: "pointer",
        }}
      >
        <img
          src={imageUrl}
          alt={data.productName || data.label}
          //   onError={(e) => {
          //     e.target.src = `${BASE_URL}media/default/lazy_placeholder.jpg`;
          //   }}
          style={{
            width: "40px",
            height: "40px",
            marginRight: "10px",
            marginLeft: "10px",
            objectFit: "cover",
            border: "0.2px solid #bcb0b0",
            borderRadius: "4px",
          }}
        />
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: "14px", fontWeight: "500" }}>
            {data.productName || data.label.split(" [")[0]}
          </div>
          {data.variantName && (
            <div style={{ fontSize: "12px", color: "#666" }}>{data.label}</div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="main-select">
      <div className="my-2 d-flex justify-content-between align-items-center gap-3">
        <div>
          <Checkbox
            checked={menuIsOpen}
            onChange={toggleMenuIsOpen}
            id="cypress-single__clearable-checkbox"
          />
          <span className="ms-2">{menuIsOpen ? "Close" : "Open"}</span>
        </div>
        <div>
          {next !== null && (
            <button
              className="btn btn-danger"
              onClick={handleLoadMore}
              disabled={loading}
            >
              {loading ? "Loading..." : "Load More"}
            </button>
          )}
        </div>
      </div>

      <div className="custom-menu">
        <Select
          components={{ Option: CustomOption }}
          ref={ref}
          menuIsOpen={menuIsOpen}
          isMulti
          placeholder="---Select---"
          isClearable
          onChange={handleMultiInputChange}
          onInputChange={inputProduct}
          options={ProductsList}
          value={defaultValue}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              borderColor: state.isFocused ? "blue" : "black",
              boxShadow: state.isFocused
                ? "0 0 0px 0.5px rgba(255, 0, 0, 1)"
                : "none",
              "&:hover": {
                borderColor: "blue",
              },
              maxHeight: "120px",
              overflowY: "auto",
            }),
            multiValueContainer: (baseStyles) => ({
              ...baseStyles,
              overflowY: "auto",
              maxHeight: "120px",
              display: "flex",
              flexWrap: "wrap",
            }),
          }}
        />
      </div>
    </div>
  );
};

export default SelectPagginationForInvoice;
